import React from 'react';
import styles from '../css/footer.module.css';

function Footer() {
    return(
        <footer className={styles.footer}>
            <p>Jammming © 2025 - Built with Spotify API </p>
        </footer>
    )
}

export default Footer;